@if (items) {
    @for (item of items; track item; let i = $index) {
        <div>
            @if (
                item.context.driveGroup &&
                (!!item.context.driveGroup.name?.trim() || !!item.context.driveGroup.title?.trim())
            ) {
                <sew-tag
                    [size]="'xs'"
                    [type]="'default'"
                    [icon]="item.context.driveGroup.iconName"
                    class="drive-group"
                >
                    {{ item.context.driveGroup.name }} {{ item.context.driveGroup.title }}
                </sew-tag>
            }
            <sew-headline level="5">
                {{
                    'X_SELLING_DIALOG.GEAR_OIL.TITLE'
                        | translate
                            : {
                                  name: item.context.name,
                                  itemNumber: item.context.itemNumber,
                                  id: item.context.id,
                              }
                }}
            </sew-headline>
            <sew-richtext>
                @if (!!item.context.name && !!item.context.gearOilQuantity && !!item.context.gearOilUnit) {
                    <p
                        translate
                        [translateParams]="{
                            lubricantName: item.context.name,
                            amount:
                                item.context.gearOilQuantity +
                                ' ' +
                                adjustGearOilUnit(item).context.gearOilUnit,
                        }"
                    >
                        X_SELLING_DIALOG.GEAR_OIL.DESCRIPTION
                    </p>
                } @else {
                    <p>
                        {{ 'X_SELLING_DIALOG.GEAR_OIL.WITHOUT_CONTEXT.DESCRIPTION_1' | translate }} <br />
                        {{ 'X_SELLING_DIALOG.GEAR_OIL.WITHOUT_CONTEXT.DESCRIPTION_2' | translate }}
                    </p>
                }
            </sew-richtext>
            <ecs-cross-selling-table
                [items]="item.parts"
                [uniqueContextSparePartId]="item.context.uniqueId"
                [userLoggedIn]="isLoggedIn"
                [showPartGroupHeaderAsSkeleton]="true"
                [checkedRows]="storedRowsPerTable[item.context.uniqueId]"
                (rowSelect)="onRowSelect(item.context.uniqueId, $event)"
            ></ecs-cross-selling-table>
        </div>
    }
} @else {
    <sew-skeleton class="skeleton-headline"></sew-skeleton>
    <sew-skeleton class="skeleton-text"></sew-skeleton>
    <sew-skeleton class="skeleton-table"></sew-skeleton>
}
